module.exports = __webpack_public_path__ + "static/cases-1-98bd54cf527d691bc755745802251141.png";